import styled from "styled-components";

export const ClickOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 15;
`;
